// extracted by mini-css-extract-plugin
export default {"languages":"languages_languages__PV8BZ","languages_open":"languages_languages_open__OYfvL","languages_title":"languages_languages_title__dxavG","lg":"languages_lg__wyudQ"};